<template>
    <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="商品列表" name="asin">
                <asin ref="asin"></asin>
            </el-tab-pane>
            <el-tab-pane label="未归类" name="aggregate">
                <aggregate ref="aggregate"></aggregate>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Asin from "./asin";
import Aggregate from "./aggregate";
export default {
    components: { Asin, Aggregate },
    data() {
        return {
            activeName: "asin"
        };
    },
    methods: {
        handleClick() {
            if (this.activeName == "aggregate") {
                this.$refs.aggregate.getList();
            } else {
                this.$refs.asin.getList();
            }
        }
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
